export const CHAT_BOTSTATUS = 'chatBotStatus'
